import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'soci',
    pathMatch: 'full'
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'soci',
    loadChildren: () => import('./pages/soci/soci.module').then( m => m.SociPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'soci/:page',
    loadChildren: () => import('./pages/soci/soci.module').then( m => m.SociPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'socio/:id',
    loadChildren: () => import('./pages/socio/socio.module').then( m => m.SocioPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'socio',
    loadChildren: () => import('./pages/socio/socio.module').then( m => m.SocioPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'azienda',
    loadChildren: () => import('./pages/azienda/azienda.module').then( m => m.AziendaPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'loculoimporti',
    loadChildren: () => import('./pages/loculoimporti/loculoimporti.module').then( m => m.LoculoimportiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'movimenti/:page',
    loadChildren: () => import('./pages/movimenti/movimenti.module').then( m => m.MovimentiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'quota',
    loadChildren: () => import('./pages/quota/quota.module').then( m => m.QuotaPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'anagrafiche',
    loadChildren: () => import('./pages\/anagrafiche/anagrafiche.module').then( m => m.AnagrafichePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'importiannuali',
    loadChildren: () => import('./pages/importiannuali/importiannuali.module').then( m => m.ImportiannualiPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'quotaannuale',
    loadChildren: () => import('./pages/quotaannuale/quotaannuale.module').then( m => m.QuotaannualePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'reports',
    loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule),
    canActivate: [AuthGuard]
  }


];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
